import { gql } from 'graphql-request'

export const GRUPOS_USUARIOS_ATIVOS_QUERY = gql`
  query gruposUsuariosQuery {
    gruposUsuariosAtivos {
      id
      nome
      publico
      favorito
    }
  }
`
